import React from 'react'
import Card from '@dashboard/components/Card'
import CardHeader from '@dashboard/components/CardHeader'
import Button from '@dashboard/components/Button'
import { MARKETING_APP_URL } from '@dashboard/lib/constants'

import css from './styles.module.scss'

interface Props {
  buttonText?: string
  buttonHREF?: string
}
interface State {}

export default class CrystalInfo extends React.Component<Props, State> {
  render() {
    return (
      <Card noPadding>
        <CardHeader title="What is Crystal?" />
        <div className={css.container}>
          <p>Crystal is an app that tells you anyone&apos;s personality.</p>
          {this.renderLink()}
        </div>
      </Card>
    )
  }

  // Partials
  renderLink() {
    const { buttonText, buttonHREF } = this.props

    if (buttonText && buttonHREF)
      return <Button href={buttonHREF}>{buttonText}</Button>
    else return <a href={MARKETING_APP_URL}>Learn more</a>
  }
}
